/** Activity Search limits (ClickUp 86d4cqpjz), shared so the API's 400s and
 * the dashboard's own guards cannot drift apart. The searched event types are
 * not here: `search_activity_summary()` fixes them in SQL, and the Activity
 * Log picks its own through `eventTypesForFilters`. */
export const ACTIVITY_SEARCH_MIN_QUERY_LENGTH = 3;
export const ACTIVITY_SEARCH_MAX_QUERY_LENGTH = 200;
/** One day, not seven (ClickUp 14zf25zmrmz): the search reads every event in
 * the range (no index narrows by event type or term), and on prod a week passes
 * the 8 s statement timeout at ~350 active doers. A day holds to only ~800-1,000
 * active doers (2026-10-28 measurement, ~6.4 µs per row); past that the fix is
 * the trigram index, ClickUp 14zf25zmv18. */
export const ACTIVITY_SEARCH_MAX_RANGE_DAYS = 1;
export const ACTIVITY_SEARCH_MAX_DOERS = 500;
/** Whether the API will accept `term` as an Activity Search term: trimmed,
 * 3-200 characters, and at least 3 of them something other than `*`. `*`
 * matches any one character, so `***` would match every title of 3 or more
 * characters. The API's 400 and the dashboard's "don't send it" guards both
 * call this, so they cannot disagree about which terms are searchable. */
export function isSearchableTerm(term) {
    const t = term.trim();
    return (t.length >= ACTIVITY_SEARCH_MIN_QUERY_LENGTH &&
        t.length <= ACTIVITY_SEARCH_MAX_QUERY_LENGTH &&
        t.replace(/\*/g, '').length >= ACTIVITY_SEARCH_MIN_QUERY_LENGTH);
}
//# sourceMappingURL=activity-search.js.map